var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
/**
 * Check if a new sleep study report is available for the patient.
 *
 * @param providerId - The provider ID (e.g., 'virtuox')
 * @param patientId - The patient ID
 * @returns ReportStatusResponse with hasNewReport flag
 * @throws ApiError if request fails (handled by interceptor)
 */
export const getReportStatus = (providerId, patientId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`/screener/providers/${providerId}/service-requests/patients/${patientId}/order-status`);
    return response.data;
});
